import { render, staticRenderFns } from "./SpeciesWise.vue?vue&type=template&id=8f24d6ce&scoped=true&"
import script from "./SpeciesWise.vue?vue&type=script&lang=js&"
export * from "./SpeciesWise.vue?vue&type=script&lang=js&"
import style0 from "./SpeciesWise.vue?vue&type=style&index=0&id=8f24d6ce&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f24d6ce",
  null
  
)

export default component.exports